import { Card, CardContent } from '@/shared/ui/card';
import { PageHeader } from '@/shared/ui/page-header';

/**
 * What a non-super-admin sees anywhere under Scraper.
 *
 * `RoleGate`'s default fallback is `null`, which renders a blank page —
 * indistinguishable from a crash to somebody who followed a link. It also lives
 * outside the route files deliberately: a Next page module may export only a
 * default and a few known config fields, and a component exported beside one
 * fails the production build with an error `tsc --noEmit` does not produce.
 */
export function ScraperDenied() {
  return (
    <div className="space-y-6">
      <PageHeader title="Scraper" description="You do not have access to this section." />
      <Card>
        <CardContent className="py-10 text-center text-sm text-muted-foreground">
          The scraper queues paid browser sessions and maintains the detection catalog, so it is
          limited to super admins. Ask one of them if you need something here.
        </CardContent>
      </Card>
    </div>
  );
}
